import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import _ from 'lodash';

import TrackRatingSection from './TrackRatingSection.jsx';
import FieldRatingSubmit from './FieldRatingSubmit.jsx';
import RatingTotal from '../RatingTotal.jsx';
import FieldTextArea from './FieldTextArea.jsx';
import FieldTextBox from './FieldTextBox.jsx';
import FieldSelectWithOther from './FieldSelectWithOther.jsx';
import FieldDate from './FieldDate.jsx';
import TrackRating from './TrackRating.jsx';

import { fetchDrivers } from '../../actions/driver';
import { removeNonHeaderFields } from '../../actions/form';

export class Simulator extends React.Component {
  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.categories = APP_CONFIG.ratings.simulator.categories;
  }

  componentDidMount() {
    this.props.fetchDrivers();
  }

  componentWillMount() {
    this.props.removeNonHeaderFields('rating');
  }

  render() {
    const { drivers } = this.props;

    return (
      <form id="simulator-rating" autoComplete="off">
        <h3>TRD Driver Rating - Simulator</h3>
        <p className="subtext">All fields marked with an asterisk symbol (*) are mandatory.</p>
        <div>
          <Row>
            <Col xs={12} sm={4}>
              <FieldTextBox placeholder="Submitter Name *" field="submitterName" />
            </Col>
            <Col xs={12} sm={4}>
              <FieldSelectWithOther
                options={drivers}
                defaultEmptyOption="Driver Name *"
                field="driverName"
              />
            </Col>
            <Col xs={12} sm={4}>
              <FieldDate />
            </Col>
          </Row>
        </div>

        <TrackRating num={1} />
        <TrackRating num={2} />
        <TrackRating num={3} />

        <TrackRatingSection fields={this.categories.general.ratings} title="General" limit={10} />

        <FieldTextArea field="additionalComments" placeholder="Additional Comments" rows={5} />
        <RatingTotal type="simulator" />
        <div className="clear"></div>
        <div className="form-submit-wrapper">
          <div className="pull-right">
            <FieldRatingSubmit formType="simulator" />
          </div>
        </div>
      </form>
    );
  }
}

export const mapStateToProps = state => ({
  drivers: _.get(state, 'driver.result', []),
  series: _.get(state, 'series.result', []),
  tracks: _.get(state, 'track.result', []),
});

export default connect(
  mapStateToProps,
  { removeNonHeaderFields, fetchDrivers },
)(Simulator);
